/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// form library
import { Controller, useFormContext } from 'react-hook-form';
// material ui components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
// custom components
import LeadNumberedHeading from '../../../../shared-components/forms/LeadNumberedHeading';
import NumberedHeading from '../../../../shared-components/forms/NumberedHeading';
import TemplateForm from './TemplateForm';

function ContentTab(props) {
  const methods = useFormContext();
  const { control } = methods;

  const { template, inputDir, section, possiblePages } = props;

  if (!template) {
    return (
      <>
        <LeadNumberedHeading
          number="3"
          title="Page Content"
          instructions="This information is used to store content from a page template. Please select a template and fill out the form completely."
        />
        <div className="flex flex-1 items-center justify-center min-h-320">
          <Typography color="text.secondary">
            Please select a template to continue...
          </Typography>
        </div>
      </>
    );
  }

  return (
    <div>
      <LeadNumberedHeading
        number="3"
        title="Page Content"
        instructions={`This information is used to store content for the ${template.title} template.`}
      />

      <Controller
        name="content"
        control={control}
        render={({ field }) => (
          <TemplateForm
            {...field}
            template={template}
            inputDir={inputDir}
            section={section}
            possiblePages={possiblePages}
          />
        )}
      />
    </div>
  );
}

export default ContentTab;
